module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/Screens/score-donut/score-donut.component.css
// module id = ./src/app/Screens/score-donut/score-donut.component.css
// module chunks = main